import { Dispatch, SetStateAction } from "react";
import styles from "./LimitReachedPopup.module.css";
import CustomModal from "../CustomModal/CustomModal";
import { useNavigate } from "react-router-dom";
import { Button } from "@shopify/polaris";
import { CurrentPlan, PLANS } from "./plansConstants";
import YellowHandIcon from "./YellowHandIcon";
const LimitReachedPopup = ({
    setPopup,
    isExhausted,
    appType = "bundles",
    currentPlan,
    currentOrders,
}: {
    currentOrders: number;
    setPopup: Dispatch<SetStateAction<boolean>>;
    isExhausted: boolean;
    currentPlan: CurrentPlan;
    appType?: "bundles" | "cart";
}) => {
    const goTo = useNavigate();

    const redirectToPlans = () => {
        if (window.location.pathname.includes("plans")) {
            setPopup(false);
        } else {
            window.localStorage.setItem("redirectToPlans", "1");
            goTo("/billing");
        }
    };
    return (
        <CustomModal title="" open={true} onClose={() => setPopup((ps) => !ps)} noClose>
            <div className={styles.limitReachWrapper}>
                <div className={styles.header}>
                    <div className={styles.popupIcon}>
                        <YellowHandIcon />{" "}
                    </div>
                    <div className={styles.titleHeader}>
                        <div>You've Hit the Limit!</div>
                    </div>
                </div>
                {[PLANS.STARTER, PLANS.FREE_NEW, PLANS.NEW_PLAN]?.includes(currentPlan?.plan_id) ? (
                    <div className={styles.middle}>
                        <div>{isExhausted ? "Limit Reached – Features Paused!" : " You’re Nearing Your Limit!"}</div>
                        <div className={styles.middle_subtext}>
                            {isExhausted
                                ? `Your plan supports up to ${currentPlan?.total_orders} orders per month, and you’ve hit the limit. Upgrade now to continue using bundles and slide cart without interruption.`
                                : `Your store has received ${currentOrders} orders, and your plan includes support for up to ${currentPlan?.total_orders} orders per month. Upgrade now to keep your bundle and slide cart features active!`}
                        </div>
                    </div>
                ) : appType == "cart" ? (
                    <div className={styles.middle}>
                        <div>You've reached 100% of your plan limit, and your cart has been deactivated.</div>
                        <div className={styles.middle_subtext}>
                            Upgrade now to keep your cart running smoothly and continue growing without interruptions!
                        </div>
                    </div>
                ) : (
                    <div className={styles.middle}>
                        <div>
                            {isExhausted
                                ? "You've reached 100% of your plan limit, and all offers have been deactivated."
                                : "You've used 80% of your plan limit."}
                        </div>
                        <div className={styles.middle_subtext}>
                            {isExhausted
                                ? " Upgrade now to keep your offers running smoothly and continue growing without interruptions!."
                                : "To keep your offers running smoothly without interruptions, upgrade your plan now and continue growing!"}
                        </div>
                    </div>
                )}
                <div className={styles.bottomCta}>
                    <Button
                        variant={"primary"}
                        onClick={() => {
                            if (isExhausted) {
                                redirectToPlans();
                            } else {
                                redirectToPlans();
                            }
                        }}
                    >
                        {"Upgrade Plan"}
                    </Button>
                </div>
            </div>
        </CustomModal>
    );
};

export default LimitReachedPopup;
